exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination[data-v-08a99a5a]{margin-top:20px;text-align:center}", ""]);

// exports
